<template>
    <dialogWrap v-model="isShow" title="绑定合作方账户银行卡" width="420px">
        <form-text-box
            ref="bindBankCardBox"
            :column="1"
            :dataList="bankCardList"
            :rules="bankCardRules"
            :formProps="formProps"
            :model="model"
        ></form-text-box>
        <template slot="footer">
            <div class="footer">
                <el-button size="small" @click="() => isShow = false">取消</el-button>
                <el-button
                :loading="loading"
                size="small"
                type="primary"
                @click="submit"
                >
                    保存
                </el-button>
            </div>
        </template>
    </dialogWrap>
</template>

<script>
import { getPayeeAccountType } from '@/api/domain/finance'
import { bankCardPreSign } from '@/api/financeApi/walletWithhold'
import { forEach } from 'lodash'
import { mapGetters } from 'vuex'
import { accountTypeENUM } from './bindBankCard'
import config from './config'

export default {
  data() {
    const { bankCardList, bankCardRules } = config.call(this)
    return {
      isShow: false,
      loading: false,
      bankCardList,
      bankCardRules,
      formProps: {
        labelWidth: '180px',
      },
      model: {
        payeeMerchantName: '',
        payeeAccountType: '',
        bankCardNo: '',
        payeeContactLine: '',
        payeeBranchName: '',
      },
      accountId: '',
    }
  },
  computed: {
    ...mapGetters(['bankChannelType']),
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    show(row, type) {
      const {
        accountId,
        payeeMerchantName,
        payeeAccountType,
        bankCardNo,
        payeeContactLine,
        payeeBranchName,
      } = row
      this.isShow = true
      if (type === 'changeBankCard') {
        this.model.payeeMerchantName = payeeMerchantName
        this.model.payeeAccountType = payeeAccountType
        this.model.bankCardNo = bankCardNo
        this.model.payeeContactLine = payeeContactLine
        this.model.payeeBranchName = payeeBranchName
      }
      this.accountId = accountId
      this.getAccountTypeList()
      this.$nextTick(() => {
        this.bindBankCardShowItem(payeeAccountType, false)
      })
    },
    async getAccountTypeList() {
      const { code, data } = await getPayeeAccountType()
      if (code === 1) {
        this.$refs.bindBankCardBox.setItemData({ elConfigKey: 'list', key: 'payeeAccountType', data })
      }
    },
    submit() {
      this.$refs.bindBankCardBox.getRefs().validate(async (validate) => {
        if (validate) {
          const { code } = await bankCardPreSign({
            channelType: this.bankChannelType,
            accountId: this.accountId,
            ...this.model,
          })
          if (code === 1) {
            this.isShow = false
            this.$emit('bindBankCardSucc')
          }
        }
      })
    },
    // 切换收款类型时，清空银行卡号, 初始化时不清空银行卡号
    bindBankCardShowItem(type, clearCardNo = true) {
      if (type === accountTypeENUM.DUI_GONG) {
        this.$refs.bindBankCardBox.setItemData({
          elConfigKey: 'isShow',
          key: 'payeeContactLine',
          data: true,
        })
        this.$refs.bindBankCardBox.setItemData({
          elConfigKey: 'isShow',
          key: 'payeeBranchName',
          data: true,
        })
        this.bankCardRules.payeeBranchName[0].required = true
        this.bankCardRules.payeeContactLine[0].required = true
        this.model.payeeBranchName = '浙江网商银行股份有限公司'
      } else {
        this.$refs.bindBankCardBox.setItemData({
          elConfigKey: 'isShow',
          key: 'payeeContactLine',
          data: false,
        })
        this.$refs.bindBankCardBox.setItemData({
          elConfigKey: 'isShow',
          key: 'payeeBranchName',
          data: false,
        })
        this.bankCardRules.payeeBranchName[0].required = false
        this.bankCardRules.payeeContactLine[0].required = false
      }
      // 收款类型为支付宝时，文案为支付宝账号，控制长度为50个字，不限制输入字符类型
      const item = this.bankCardList.find((element) => element.itemConfig.prop === 'bankCardNo')
      item.itemConfig.label = type === accountTypeENUM.ALIPAY ? '支付宝账号' : '收款人卡号'
      const message = type === accountTypeENUM.ALIPAY ? '请输入支付宝账号' : '请输入收款人卡号'
      const getInputValue = (val) => {
        return type === accountTypeENUM.ALIPAY ? val : val.replace(/\D/g, '')
      }

      if (clearCardNo) {
        this.model.bankCardNo = ''
      }
      this.bankCardRules.bankCardNo[0].message = message
      this.$refs.bindBankCardBox.getRefs()?.clearValidate('bankCardNo')
      item.elConfig.events = {
        input: (val) => {
          this.model.bankCardNo = getInputValue(val)
        },
      }
    },
  },
  watch: {
    isShow: {
      handler(val) {
        if (!val) {
          this.$refs.bindBankCardBox.getRefs().resetFields()
          forEach(this.model, (_, key) => {
            this.model[key] = ''
          })
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
    text-align: center;
}
</style>
